import { defineElement, TemplateElement, html } from '@webtides/element-js';

export default class ItemListSnippet extends TemplateElement {
    constructor() {
        super({
            autoUpdate: false,
            deferUpdate: true,
            propertyOptions: {
                products: { reflect: false },
            },
        });
    }

    properties() {
        return {
            originalUrl: '',
            products: [],
        };
    }

    watch() {
        return {
            products: () => {
                if (this.products.length > 0) {
                    this.requestUpdate();
                }
            },
        };
    }

    get productJson() {
        const flatProducts = this.products.flatMap(product =>
            Object.values(product.frames).flatMap(value => value.products),
        );

        const data = {
            '@context': 'http://schema.org',
            '@type': 'ItemList',
            url: this.originalUrl,
            numberOfItems: flatProducts.length,
            itemListElement: flatProducts.map((product, index) => ({
                '@type': 'ListItem',
                position: index,
                url: product.href,
            })),
        };

        return JSON.stringify(data);
    }

    template() {
        return `<script type="application/ld+json">${this.productJson}</script>`;
    }
}

defineElement('item-list-snippet', ItemListSnippet);
